import { getToken } from '../../../helpers/Token';

export const login = (
  state = { userRole: 'person', loggedInUser: getToken() },
  action
) => {
  switch (action.type) {
    case 'LOGIN_WITH_EMAIL': {
      return { ...state, values: action.payload };
    }
    case 'LOGIN_WITH_FB': {
      return { ...state, values: action.payload };
    }
    case 'LOGIN_WITH_TWITTER': {
      return { ...state, values: action.payload };
    }
    case 'LOGIN_WITH_GOOGLE': {
      return { ...state, values: action.payload };
    }
    case 'LOGIN_WITH_GITHUB': {
      return { ...state, values: action.payload };
    }
    case 'LOGIN_WITH_JWT': {
      return { ...state, ...action.payload };
    }
    case 'LOGOUT_WITH_JWT': {
      return { ...state, userRole: 'person', loggedInUser: undefined };
    }
    case 'CHANGE_ROLE': {
      return { ...state, userRole: action.userRole };
    }
    default: {
      return state;
    }
  }
};
